<template>
  <section
    :class="['city-location', isXl && 'xl']"
    :style="styleObj"
    v-if="actData"
  >
    <p>
      <img src="../assets/images/city_location.png" alt="" />
      <span>{{ cityName }}</span>
    </p>
  </section>
</template>
<script>
import { translateVw, isXL } from '../utils/index';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      isXl: isXL()
    };
  },
  props: [
    'verticalDirection', // 固定为 top
    'verticalDistance',
    'horizontalDirection', // 'left' | 'right'
    'horizontalDistance'
  ],
  computed: {
    ...mapState('app', ['actData']),
    styleObj() {
      let style = {};
      let verticalDirection = this.verticalDirection;
      let horizontalDirection = this.horizontalDirection;
      style[verticalDirection] = translateVw(this.verticalDistance);
      style[horizontalDirection] = translateVw(this.horizontalDistance);
      console.log(style, '456784567');
      return style;
    },
    cityName() {
      return this.actData.cityName || '获取定位失败';
    }
  }
};
</script>
<style lang="less" scoped>
.city-location {
  position: absolute;
  z-index: 1;
  &.xl {
    > p {
      background-color: rgba(255, 67, 130, 0.5);
    }
  }
  > p {
    .fc;
    height: 48px;
    max-width: 218px;
    background-color: rgba(253, 153, 81, 0.5);
    border-radius: 24px;
    padding: 0 20px;
    box-sizing: border-box;
    > img {
      height: 25px;
    }
    > span {
      font-size: 30px;
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
      max-width: 90%;
      margin-left: 5px;
      letter-spacing: 2px;
      .ellipsis;
    }
  }
}</style
>>
